import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import CanEndiannessVisualizer from '../components/tools/canEndianness/CanEndiannessVisualizer';
import { usePageSeo } from '../hooks/usePageSeo';

const PAGE_TITLE = 'CAN Endianness Visualizer | AUTOXIUM';
const PAGE_DESCRIPTION = 'Visualize how Intel (Little Endian) and Motorola (Big Endian) CAN signals pack into CAN data bytes, with an interactive bit grid, live decode, and DBC output.';

const CanEndiannessVisualizerPage = () => {
  usePageSeo(PAGE_TITLE, PAGE_DESCRIPTION);

  return (
    <div className="min-h-screen" data-testid="can-endianness-visualizer-page">
      <PageHero
        eyebrow="Engineering Utilities / Communication"
        title="CAN Endianness Visualizer"
        description="See exactly how Intel (Little Endian) and Motorola (Big Endian) CAN signals pack into data bytes — build a signal set, click bits directly in the grid, and get a live decode plus DBC definition for each signal."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="can-endianness-visualizer-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <CanEndiannessVisualizer />
          <ToolGuideCta guidePath="/tools/can-endianness-visualizer/guide" toolName="CAN Endianness Visualizer" />
        </div>
      </section>
    </div>
  );
};

export default CanEndiannessVisualizerPage;
